import snackbar from '@/store/common-modules/snackbar';
import header from '@/store/common-modules/header';

export default {
    modules: {
        snackbar,
        header
    },
}